import { render, staticRenderFns } from "./gender_selection.vue?vue&type=template&id=57892236"
import script from "./gender_selection.vue?vue&type=script&lang=js"
export * from "./gender_selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports